import metaApiClient from './meta-client';

export interface AiTokenUsageRecord {
    id: number;
    provider: string;
    model: string;
    input_tokens: number;
    output_tokens: number;
    total_tokens: number;
    source_type: string;
    reference_id: number | null;
    reference_name: string | null;
    target_language: string | null;
    cost_estimate_usd: number;
    created_at: string;
}

export interface AiTokenUsageList {
    total: number;
    page: number;
    per_page: number;
    data: AiTokenUsageRecord[];
}

export interface AiTokenUsageSummary {
    period_days: number;
    totals: {
        calls: number;
        input_tokens: number;
        output_tokens: number;
        total_tokens: number;
        cost_usd: number;
    };
    by_provider: { provider: string; calls: number; tokens: number; cost_usd: number }[];
    by_source: { source_type: string; calls: number; tokens: number; cost_usd: number }[];
    daily: { day: string; tokens: number; cost_usd: number; calls: number }[];
}

export const getAiTokenUsage = async (params?: {
    source_type?: string;
    provider?: string;
    reference_id?: number;
    days?: number;
    page?: number;
    per_page?: number;
}): Promise<AiTokenUsageList> => {
    const response = await metaApiClient.get<AiTokenUsageList>('/meta/ai-token-usage', { params });
    return response.data;
};

export const getAiTokenUsageSummary = async (days?: number): Promise<AiTokenUsageSummary> => {
    const response = await metaApiClient.get<AiTokenUsageSummary>('/meta/ai-token-usage/summary', {
        params: days ? { days } : undefined,
    });
    return response.data;
};

export interface AiTokenGroupBroadcast {
    broadcast_id: number;
    target_language: string | null;
    provider: string;
    model: string;
    input_tokens: number;
    output_tokens: number;
    total_tokens: number;
    cost_usd: number;
    page_id: string;
    broadcast_status: string;
    total_sent: number;
    total_failed: number;
}

export interface AiTokenGroupResponse {
    group: {
        group_broadcast_id: number;
        title: string;
        total_broadcasts: number;
        total_leads: number;
        total_sent: number;
        total_failed: number;
        started_at: string | null;
        completed_at: string | null;
    } | null;
    tokens: {
        calls: number;
        input_tokens: number;
        output_tokens: number;
        total_tokens: number;
        cost_usd: number;
    };
    by_language: { language: string; calls: number; tokens: number; cost_usd: number }[];
    per_broadcast: AiTokenGroupBroadcast[];
}

export const getAiTokenUsageByGroup = async (groupBroadcastId: number): Promise<AiTokenGroupResponse> => {
    const response = await metaApiClient.get<AiTokenGroupResponse>(`/meta/ai-token-usage/group/${groupBroadcastId}`);
    return response.data;
};
